export type SectionVariant = "dark" | "light";

export function sectionSurface(variant: SectionVariant = "dark") {
  if (variant === "light") {
    return {
      section: "bg-[#f3f3f3]",
      sectionPlain: "bg-[#f3f3f3]",
      heading: "text-[#1C1C1C]",
      body: "text-zinc-500",
      bodyMuted: "text-zinc-500",
      labelMuted: "text-zinc-400",
      divider: "border-zinc-200",
      faqCard:
        "group rounded-2xl border border-zinc-200 bg-white shadow-sm transition-all duration-300 hover:border-zinc-300 hover:shadow-md",
      faqQuestion: "text-base sm:text-lg font-bold text-[#1C1C1C] pr-2 sm:pr-8 flex-1 min-w-0",
      faqAnswer: "text-sm sm:text-base text-zinc-600 leading-relaxed whitespace-pre-line",
      faqChevron:
        "shrink-0 h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-zinc-100 border border-zinc-200 flex items-center justify-center transition-transform duration-300",
      faqChevronIcon: "text-[#1C1C1C] text-[10px] sm:text-xs",
      buttonGhost:
        "rounded-full border border-zinc-300 bg-white px-6 py-3 text-sm font-semibold text-[#1C1C1C] transition hover:border-zinc-400 hover:bg-zinc-50",
      offerChoice:
        "group rounded-xl border-2 border-zinc-200 bg-white px-6 py-4 text-left transition-all hover:border-[#71DDAE] hover:shadow-md flex items-center gap-3",
    } as const;
  }

  return {
    section: "border-t border-white/10 bg-[color:var(--color-background-strong)]",
    sectionPlain: "border-t border-white/10",
    heading: "text-white",
    body: "text-white/80",
    bodyMuted: "text-white/75",
    labelMuted: "text-white/45",
    divider: "border-white/10",
    faqCard:
      "group rounded-2xl border border-white/10 bg-white/5 backdrop-blur-lg shadow-lg transition-all duration-300 hover:border-white/20 hover:bg-white/10",
    faqQuestion: "text-base sm:text-lg font-bold text-white pr-2 sm:pr-8 flex-1 min-w-0",
    faqAnswer: "text-sm sm:text-base text-white/80 leading-relaxed whitespace-pre-line",
    faqChevron:
      "shrink-0 h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-white/20 border border-white/30 flex items-center justify-center transition-transform duration-300",
    faqChevronIcon: "text-white text-[10px] sm:text-xs",
    buttonGhost:
      "rounded-full border border-white/20 bg-white/5 px-6 py-3 text-sm font-semibold text-white transition hover:border-white/40 hover:bg-white/10",
    offerChoice:
      "group rounded-xl border-2 border-white/20 bg-white/5 px-6 py-4 text-left transition-all hover:border-[#71DDAE] hover:bg-white/10 flex items-center gap-3",
  } as const;
}
